import { primaryColor } from '../../config/theme';

const styles = {
  btnText: {
    fontFamily: 'Poppins',
    fontSize: 14
  },
  filterBtn: {
    color: '#fff',
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 20,
    marginRight: 20,
    marginTop: 150,
    minWidth: 200,
    textTransform: 'none',
  },
  filterBtnText: {
    fontFamily: 'Poppins',
    fontSize: 18
  },
  filterItemText: {
    color: '#000',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: '500',
  },
  filterItemTextSelected: {
    color: primaryColor,
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: '500',
  },
  listItemText: {
    color: '#000',
    cursor: 'pointer',
    fontFamily:'Poppins',
    fontSize: 24,
    fontWeight: '500',
  },
  selectedBtn: {
    backgroundColor: '#fff',
    color: primaryColor,
    borderColor: primaryColor,
    borderRadius: 20,
    marginRight: 20,
    minWidth: 100,
    textTransform: 'none',
  },
  simpleBtn: {
    color: '#fff',
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 20,
    marginRight: 20,
    minWidth: 100,
    textTransform: 'none',
  },
  tableCell: {
    color: '#000',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: '500',
  },
  tableCellAmount: {
    color: primaryColor,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center'
  },
  tableBookingId: {
    color: primaryColor,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: '600',
    cursor: 'pointer'
  },
  tableHead: {
    color: '#000',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: '500',
  }
};

export default styles;
